import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { StartedNotSubmittedRow } from '../../../api/types';
import { withTime } from '../../../lib/dates';

/** Collapsible list of students who opened the exam but have no result. Renders nothing when empty. */
export default function StartedNotSubmitted({ items }: { items?: StartedNotSubmittedRow[] }) {
  const [open, setOpen] = useState(false);
  if (!items || items.length === 0) return null;
  const label = `Started but didn't submit (${items.length})`;
  return (
    <div className="mt-4 rounded-[14px] border border-hairline px-4 py-3">
      <button type="button" aria-expanded={open} className="text-[13px] font-semibold text-muted-2" onClick={() => setOpen((o) => !o)}>{label}</button>
      {open && (
        <ul className="mt-2 space-y-1 text-[13px]">
          {items.map((s) => (
            <li key={s.student_id} className="flex flex-wrap items-center gap-2">
              <Link className="font-semibold text-ink no-underline hover:underline" to={`/students/profile/${s.student_id}`}>{s.name}</Link>
              <span className="text-muted">{`started ${withTime(s.started_at, { day: 'numeric', month: 'short' })}`}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
